require('bootstrap');
require('./custom.js');
var css = require("../sass/main.scss");



//////////////////
// WEBPACK FOOTER
// ./assets/js/entry.js
// module id = 0
// module chunks = 0